import {
  CREATE_ACTIONS_FAILURE,
  CREATE_ACTIONS_REQUEST,
  CREATE_ACTIONS_SUCCESS,
  CREATE_API_FAILURE,
  CREATE_API_REQUEST,
  CREATE_API_SUCCESS,
  CREATE_MAP_FAILURE,
  CREATE_MAP_REQUEST,
  CREATE_MAP_SUCCESS,
  CREATE_MODULE_FAILURE,
  CREATE_MODULE_REQUEST,
  CREATE_MODULE_SUCCESS,
  CREATE_SUBMODULE_FAILURE,
  CREATE_SUBMODULE_REQUEST,
  CREATE_SUBMODULE_SUCCESS,
  EDIT_ACTIONS_FAILURE,
  EDIT_ACTIONS_REQUEST,
  EDIT_ACTIONS_SUCCESS,
  EDIT_API_FAILURE,
  EDIT_API_REQUEST,
  EDIT_API_SUCCESS,
  EDIT_MODULE_FAILURE,
  EDIT_MODULE_REQUEST,
  EDIT_MODULE_SUCCESS,
  EDIT_SUBMODULE_FAILURE,
  EDIT_SUBMODULE_REQUEST,
  EDIT_SUBMODULE_SUCCESS,
  GET_ACTION_BY_SUBMODULES_FAILURE,
  GET_ACTION_BY_SUBMODULES_REQUEST,
  GET_ACTION_BY_SUBMODULES_SUCCESS,
  GET_ACTIONS_FAILURE,
  GET_ACTIONS_FOR_MAPPING_FAILURE,
  GET_ACTIONS_FOR_MAPPING_REQUEST,
  GET_ACTIONS_FOR_MAPPING_SUCCESS,
  GET_ACTIONS_REQUEST,
  GET_ACTIONS_SUCCESS,
  GET_API_FAILURE,
  GET_API_REQUEST,
  GET_API_SUCCESS,
  GET_CLIENTS_FAILURE,
  GET_CLIENTS_REQUEST,
  GET_CLIENTS_SUCCESS,
  GET_COMPONENTS_FAILURE,
  GET_COMPONENTS_REQUEST,
  GET_COMPONENTS_SUCCESS,
  GET_MODULES_FAILURE,
  GET_MODULES_REQUEST,
  GET_MODULES_SUCCESS,
  GET_MODULESBY_SUBMODULES_FAILURE,
  GET_MODULESBY_SUBMODULES_REQUEST,
  GET_MODULESBY_SUBMODULES_SUCCESS,
  GET_SUBMODULES_FAILURE,
  GET_SUBMODULES_REQUEST,
  GET_SUBMODULES_SUCCESS,
  GET_USERS_BY_CLIENTID_FAILURE,
  GET_USERS_BY_CLIENTID_REQUEST,
  GET_USERS_BY_CLIENTID_SUCCESS,
} from "./moduleManagementTypes";
import axios from "axios";
import Config from "../../config/index";
let baseUrl = Config.baseUrl;

let userManagementUrl = Config.userManagementUrl;

const createModuleForModuleManagementRequest = () => {
  return {
    type: CREATE_MODULE_REQUEST,
  };
};

const createModuleForModuleManagementSuccess = (payload) => {
  return {
    type: CREATE_MODULE_SUCCESS,
    payload: payload,
  };
};

const createModuleForModuleManagementFailure = (error) => {
  return {
    type: CREATE_MODULE_FAILURE,
    payload: error,
  };
};

const createModuleForModuleManagement = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createModuleForModuleManagementRequest());
    let url = `${userManagementUrl}/modules/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createModuleForModuleManagementSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createModuleForModuleManagementFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};
const createApiForModuleManagementRequest = () => {
  return {
    type: CREATE_API_REQUEST,
  };
};

const createApiForModuleManagementSuccess = (payload) => {
  return {
    type: CREATE_API_SUCCESS,
    payload: payload,
  };
};

const createApiForModuleManagementFailure = (error) => {
  return {
    type: CREATE_API_FAILURE,
    payload: error,
  };
};

const createApiForModuleManagement = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createApiForModuleManagementRequest());
    let url = `${userManagementUrl}/api/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createApiForModuleManagementSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createApiForModuleManagementFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const createActionForModuleManagementRequest = () => {
  return {
    type: CREATE_ACTIONS_REQUEST,
  };
};

const createActionForModuleManagementSuccess = (payload) => {
  return {
    type: CREATE_ACTIONS_SUCCESS,
    payload: payload,
  };
};

const createActionForModuleManagementFailure = (error) => {
  return {
    type: CREATE_ACTIONS_FAILURE,
    payload: error,
  };
};

const createActionForModuleManagement = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createActionForModuleManagementRequest());
    let url = `${userManagementUrl}/actions/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createActionForModuleManagementSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createActionForModuleManagementFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};
const createSubModuleForModuleManagementRequest = () => {
  return {
    type: CREATE_SUBMODULE_REQUEST,
  };
};

const createSubModuleForModuleManagementSuccess = (payload) => {
  return {
    type: CREATE_SUBMODULE_SUCCESS,
    payload: payload,
  };
};

const createSubModuleForModuleManagementFailure = (error) => {
  return {
    type: CREATE_SUBMODULE_FAILURE,
    payload: error,
  };
};

const createSubModuleForModuleManagement = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(createSubModuleForModuleManagementRequest());
    let url = `${userManagementUrl}/sub-module/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(createSubModuleForModuleManagementSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(createSubModuleForModuleManagementFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};
const mapActionForModuleManagementRequest = () => {
  return {
    type: CREATE_MAP_REQUEST,
  };
};

const mapActionForModuleManagementSuccess = (payload) => {
  return {
    type: CREATE_MAP_SUCCESS,
    payload: payload,
  };
};

const mapActionForModuleManagementFailure = (error) => {
  return {
    type: CREATE_MAP_FAILURE,
    payload: error,
  };
};

const mapActionForModuleManagement = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(mapActionForModuleManagementRequest());
    let url = `${userManagementUrl}/action_sub_module_map/create`;
    return axios
      .post(url, payload, headers)
      .then((response) => {
        dispatch(mapActionForModuleManagementSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(mapActionForModuleManagementFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const getSubModulesForModuleManagementRequest = () => {
  return {
    type: GET_SUBMODULES_REQUEST,
  };
};

const getSubModulesForModuleManagementSuccess = (payload) => {
  return {
    type: GET_SUBMODULES_SUCCESS,
    payload: payload,
  };
};

const getSubModulesForModuleManagementFaliure = (error) => {
  return {
    type: GET_SUBMODULES_FAILURE,
    payload: error,
  };
};

const getSubModulesForModuleManagement = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getSubModulesForModuleManagementRequest());
    let url = `${userManagementUrl}/sub-module/`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getSubModulesForModuleManagementSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getSubModulesForModuleManagementFaliure(err.response));
      });
  };
};

const getModulesForModuleManagementRequest = () => {
  return {
    type: GET_MODULES_REQUEST,
  };
};

const getModulesForModuleManagementSuccess = (payload) => {
  return {
    type: GET_MODULES_SUCCESS,
    payload: payload,
  };
};

const getModulesForModuleManagementFaliure = (error) => {
  return {
    type: GET_MODULES_FAILURE,
    payload: error,
  };
};

const getModulesForModuleManagement = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getModulesForModuleManagementRequest());
    let url = `${userManagementUrl}/modules/get_all`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getModulesForModuleManagementSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getModulesForModuleManagementFaliure(err.response));
      });
  };
};

const getComponentsForModuleManagementRequest = () => {
  return {
    type: GET_COMPONENTS_REQUEST,
  };
};

const getComponentsForModuleManagementSuccess = (payload) => {
  return {
    type: GET_COMPONENTS_SUCCESS,
    payload: payload,
  };
};

const getComponentsForModuleManagementFaliure = (error) => {
  return {
    type: GET_COMPONENTS_FAILURE,
    payload: error,
  };
};

const getComponentsForModuleManagement = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getComponentsForModuleManagementRequest());
    let url = `${userManagementUrl}/components/get_all`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getComponentsForModuleManagementSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getComponentsForModuleManagementFaliure(err.response));
      });
  };
};

const getActionsForModuleManagementRequest = () => {
  return {
    type: GET_ACTIONS_REQUEST,
  };
};

const getActionsForModuleManagementSuccess = (payload) => {
  return {
    type: GET_ACTIONS_SUCCESS,
    payload: payload,
  };
};

const getActionsForModuleManagementFaliure = (error) => {
  return {
    type: GET_ACTIONS_FAILURE,
    payload: error,
  };
};

const getActionsForModuleManagement = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getActionsForModuleManagementRequest());
    let url = `${userManagementUrl}/actions/get`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getActionsForModuleManagementSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getActionsForModuleManagementFaliure(err.response));
      });
  };
};

const getApiForModuleManagementRequest = () => {
  return {
    type: GET_API_REQUEST,
  };
};

const getApiForModuleManagementSuccess = (payload) => {
  return {
    type: GET_API_SUCCESS,
    payload: payload,
  };
};

const getApiForModuleManagementFaliure = (error) => {
  return {
    type: GET_API_FAILURE,
    payload: error,
  };
};

const getApiForModuleManagement = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getApiForModuleManagementRequest());
    let url = `${userManagementUrl}/api/get_all_apis`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getApiForModuleManagementSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getApiForModuleManagementFaliure(err.response));
      });
  };
};

const getActionsForMapingRequest = () => {
  return {
    type: GET_ACTIONS_FOR_MAPPING_REQUEST,
  };
};

const getActionsForMapingSuccess = (payload) => {
  return {
    type: GET_ACTIONS_FOR_MAPPING_SUCCESS,
    payload: payload,
  };
};

const getActionsForMapingFaliure = (error) => {
  return {
    type: GET_ACTIONS_FOR_MAPPING_FAILURE,
    payload: error,
  };
};

const getActionsForMaping = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getActionsForMapingRequest());
    let url = `${userManagementUrl}/actions/get_all`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getActionsForMapingSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getActionsForMapingFaliure(err.response));
      });
  };
};


const updateModuleForManagementRequest = () => {
  return {
    type: EDIT_MODULE_REQUEST,
  };
};

const updateModuleForManagementSuccess = (payload) => {
  return {
    type: EDIT_MODULE_SUCCESS,
    payload: payload,
  };
};

const updateModuleForManagementFailure = (error) => {
  return {
    type: EDIT_MODULE_FAILURE,
    payload: error,
  };
};

const updateModuleForManagement = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateModuleForManagementRequest());
    let url = `${userManagementUrl}/modules/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateModuleForManagementSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateModuleForManagementFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateSubModuleForManagementRequest = () => {
  return {
    type: EDIT_SUBMODULE_REQUEST,
  };
};

const updateSubModuleForManagementSuccess = (payload) => {
  return {
    type: EDIT_SUBMODULE_SUCCESS,
    payload: payload,
  };
};

const updateSubModuleForManagementFailure = (error) => {
  return {
    type: EDIT_SUBMODULE_FAILURE,
    payload: error,
  };
};

const updateSubModuleForManagement = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateSubModuleForManagementRequest());
    let url = `${userManagementUrl}/sub-module/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateSubModuleForManagementSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateSubModuleForManagementFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateActionForModuleManagementRequest = () => {
  return {
    type: EDIT_ACTIONS_REQUEST,
  };
};

const updateActionForModuleManagementSuccess = (payload) => {
  return {
    type: EDIT_ACTIONS_SUCCESS,
    payload: payload,
  };
};

const updateActionForModuleManagementFailure = (error) => {
  return {
    type: EDIT_ACTIONS_FAILURE,
    payload: error,
  };
};

const updateActionForModuleManagement = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateActionForModuleManagementRequest());
    let url = `${userManagementUrl}/actions/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateActionForModuleManagementSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateActionForModuleManagementFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};

const updateApiForModuleManagementRequest = () => {
  return {
    type: EDIT_API_REQUEST,
  };
};

const updateApiForModuleManagementSuccess = (payload) => {
  return {
    type: EDIT_API_SUCCESS,
    payload: payload,
  };
};

const updateApiForModuleManagementFailure = (error) => {
  return {
    type: EDIT_API_FAILURE,
    payload: error,
  };
};

const updateApiForModuleManagement = (payload, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(updateApiForModuleManagementRequest());
    let url = `${userManagementUrl}/api/update`;
    return axios
      .put(url, payload, headers)
      .then((response) => {
        dispatch(updateApiForModuleManagementSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(updateApiForModuleManagementFailure(err.response));
        return { status: false, data: err.response };
      });
  };
};


const getsubModuleByModuleRequest = () => {
  return {
    type: GET_MODULESBY_SUBMODULES_REQUEST,
  };
};

const getsubModuleByModuleSuccess = (payload) => {
  return {
    type: GET_MODULESBY_SUBMODULES_SUCCESS,
    payload: payload,
  };
};

const getsubModuleByModuleFaliure = (error) => {
  return {
    type: GET_MODULESBY_SUBMODULES_FAILURE,
    payload: error,
  };
};

const getsubModuleByModule = (moduleId,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getsubModuleByModuleRequest());
    let url = `${userManagementUrl}/sub-module/get_by_moduleId?moduleId=${moduleId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getsubModuleByModuleSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getsubModuleByModuleFaliure(err.response));
      });
  };
};

const getActionBySubModuleRequest = () => {
  return {
    type: GET_ACTION_BY_SUBMODULES_REQUEST,
  };
};

const getActionBySubModuleSuccess = (payload) => {
  return {
    type: GET_ACTION_BY_SUBMODULES_SUCCESS,
    payload: payload,
  };
};

const getActionBySubModuleFaliure = (error) => {
  return {
    type: GET_ACTION_BY_SUBMODULES_FAILURE,
    payload: error,
  };
};

const getActionBySubModule = (moduleId,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getActionBySubModuleRequest());
    let url = `${userManagementUrl}/actions/get_by_subModule?subModuleId=${moduleId}`;
    axios
      .get(url, headers)
      .then((response) => {
        dispatch(getActionBySubModuleSuccess(response.data));
      })
      .catch((err) => {
        dispatch(getActionBySubModuleFaliure(err.response));
      });
  };
};

const getAllClientsRequest = () => {
  return {
    type: GET_CLIENTS_REQUEST,
  };
};

const getAllClientsSuccess = (payload) => {
  return {
    type: GET_CLIENTS_SUCCESS,
    payload: payload,
  };
};

const getAllClientsFaliure = (error) => {
  return {
    type: GET_CLIENTS_FAILURE,
    payload: error,
  };
};

const getAllClients = (jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getAllClientsRequest());
    let url = `${userManagementUrl}/roles/get_clients`;
    return axios
      .get(url, headers)
      .then((response) => {
        dispatch(getAllClientsSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getAllClientsFaliure(err.message));
        return { status: false };
      });
  };
};


const getUsersByClientIdRequest = () => {
  return {
    type: GET_USERS_BY_CLIENTID_REQUEST,
  };
};

const getUsersByClientIdSuccess = (payload) => {
  return {
    type: GET_USERS_BY_CLIENTID_SUCCESS,
    payload: payload,
  };
};

const getUsersByClientIdFaliure = (error) => {
  return {
    type: GET_USERS_BY_CLIENTID_FAILURE,
    payload: error,
  };
};

const getUsersByClientId = (clientId,jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getUsersByClientIdRequest());
    // let url = `${userManagementUrl}/roles/get_all_by_clientId?clientId=${clientId}`;
    let url = `${userManagementUrl}/roles/get_admins_by_clientId?clientId=${clientId}`;
    return axios
      .get(url, headers)
      .then((response) => {
        dispatch(getUsersByClientIdSuccess(response.data));
        return { status: true, data: response.data };
      })
      .catch((err) => {
        dispatch(getUsersByClientIdFaliure(err.message));
        return { status: false };
      });
  };
};

export {
  createModuleForModuleManagement,
  getSubModulesForModuleManagement,
  getAllClients,
  getModulesForModuleManagement,
  createSubModuleForModuleManagement,
  getComponentsForModuleManagement,
  getActionsForModuleManagement,
  getsubModuleByModule,
  createActionForModuleManagement,
  getApiForModuleManagement,
  getActionBySubModule,
  createApiForModuleManagement,
  updateModuleForManagement,
  updateSubModuleForManagement,
  updateActionForModuleManagement,
  updateApiForModuleManagement,
  getActionsForMaping,
  mapActionForModuleManagement,
  getUsersByClientId,
};
